<template>
  <div class="uid-pool-page">
    <!-- 池状态统计 -->
    <div class="section stats-row">
      <el-card shadow="never" class="stat-card">
        <div class="stat-label">普通号剩余</div>
        <div class="stat-value" translate="no">{{ poolInfo.regular_count }}</div>
      </el-card>
      <el-card shadow="never" class="stat-card">
        <div class="stat-label">靓号剩余</div>
        <div class="stat-value" translate="no">{{ poolInfo.fancy_count }}</div>
      </el-card>
      <el-card shadow="never" class="stat-card">
        <div class="stat-label">当前玩家总数</div>
        <div class="stat-value" translate="no">{{ poolInfo.player_count }}</div>
      </el-card>
      <el-button icon="el-icon-refresh" :loading="loadingInfo" @click="loadPoolInfo" style="align-self:center">刷新</el-button>
    </div>

    <!-- 预生成区域 -->
    <div class="section">
      <el-form inline @submit.native.prevent>
        <el-form-item label="生成数量（最多2000）">
          <el-input-number v-model="batchCount" :min="1" :max="2000" style="width:150px"></el-input-number>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" :loading="generating" @click="generateBatch">预生成 ID</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- 分类区域 -->
    <div class="section" v-if="transferData.length > 0">
      <el-alert type="info" :closable="false" style="margin-bottom:12px"
        :title="`共 ${transferData.length} 个待分类 ID，请将靓号移至右侧，普通号留在左侧`">
      </el-alert>
      <el-transfer
        v-model="fancyIds"
        :data="transferData"
        :titles="['普通号', '靓号']"
        filterable
        filter-placeholder="搜索 ID"
      ></el-transfer>
      <div style="margin-top:16px">
        <el-button type="success" :loading="submitting" @click="submitIds">提交入池</el-button>
        <el-button @click="clearTransfer">清空</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { getPoolInfo, generateUserIdBatch, submitRegularIds, submitFancyIds } from '../api'

export default {
  name: 'UserIdPool',
  data() {
    return {
      batchCount: 500,
      generating: false,
      submitting: false,
      loadingInfo: false,
      transferData: [],
      fancyIds: [],
      poolInfo: {
        regular_count: '-',
        fancy_count: '-',
        player_count: '-',
      },
    }
  },
  mounted() {
    this.loadPoolInfo()
  },
  methods: {
    loadPoolInfo() {
      this.loadingInfo = true
      getPoolInfo({}).then((res) => {
        if (res.data.errcode === 0 && res.data.params.status === 0) {
          const p = res.data.params
          this.poolInfo = {
            regular_count: p.regular_count,
            fancy_count: p.fancy_ids ? p.fancy_ids.length : 0,
            player_count: p.player_count,
          }
          // 若有未分类 ID，自动填入 transfer 供分类
          if (p.unclassified_ids && p.unclassified_ids.length > 0) {
            this.transferData = p.unclassified_ids.map(id => ({ key: String(id), label: String(id) }))
            this.fancyIds = []
            this.$message({ message: `检测到 ${p.unclassified_ids.length} 个未分类 ID，请先完成分类`, type: 'warning', offset: 80 })
          }
        } else {
          const msg = (res.data.params && res.data.params.msg) || '获取池信息失败'
          this.$message({ message: msg, type: 'error', offset: 80 })
        }
      }).finally(() => {
        this.loadingInfo = false
      })
    },
    generateBatch() {
      if (this.transferData.length > 0) {
        this.$message({ message: '存在未分类 ID，请先提交后再生成新一批', type: 'warning', offset: 80 })
        return
      }
      this.generating = true
      generateUserIdBatch({ count: this.batchCount }).then((res) => {
        if (res.data.errcode === 0 && res.data.params.status === 0) {
          const ids = res.data.params.ids
          this.transferData = ids.map(id => ({ key: String(id), label: String(id) }))
          this.fancyIds = []
          this.$message({ message: `预生成 ${ids.length} 个 ID`, type: 'success', offset: 80 })
        } else {
          const msg = (res.data.params && res.data.params.msg) || '预生成失败'
          this.$message({ message: msg, type: 'error', offset: 80 })
        }
      }).finally(() => {
        this.generating = false
      })
    },
    submitIds() {
      if (this.transferData.length === 0) return

      const regularIds = this.transferData
        .map(item => item.key)
        .filter(k => !this.fancyIds.includes(k))
        .map(Number)
      const fancyIds = this.fancyIds.map(Number)

      const requests = []
      if (regularIds.length > 0) requests.push(submitRegularIds({ ids: regularIds }))
      if (fancyIds.length > 0) requests.push(submitFancyIds({ ids: fancyIds }))
      if (requests.length === 0) return

      this.submitting = true
      Promise.all(requests).then((results) => {
        const allOk = results.every(res => res.data.errcode === 0 && res.data.params.status === 0)
        if (allOk) {
          let msg = ''
          if (regularIds.length > 0) msg += `普通号 ${regularIds.length} 个`
          if (fancyIds.length > 0) msg += `${msg ? '，' : ''}靓号 ${fancyIds.length} 个`
          this.$message({ message: `入池成功：${msg}`, type: 'success', offset: 80 })
          this.clearTransfer()
          this.loadPoolInfo()
        } else {
          const failed = results.find(res => !(res.data.errcode === 0 && res.data.params.status === 0))
          const msg = (failed.data.params && failed.data.params.msg) || '提交失败'
          this.$message({ message: msg, type: 'error', offset: 80 })
        }
      }).finally(() => {
        this.submitting = false
      })
    },
    clearTransfer() {
      this.transferData = []
      this.fancyIds = []
    },
  }
}
</script>

<style scoped>
.uid-pool-page {
  padding: 16px;
}
.section {
  margin-bottom: 24px;
}
.stats-row {
  display: flex;
  gap: 16px;
  align-items: stretch;
}
.stat-card {
  min-width: 120px;
  text-align: center;
}
.stat-label {
  font-size: 12px;
  color: #909399;
  margin-bottom: 4px;
}
.stat-value {
  font-size: 24px;
  font-weight: 600;
  color: #303133;
}
</style>



// WEBPACK FOOTER //
// src/views/UserIdPool.vue